var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M8.50002 1.41666C4.5971 1.41666 1.41669 4.59707 1.41669 8.49999C1.41669 12.4029 4.5971 15.5833 8.50002 15.5833C12.4029 15.5833 15.5834 12.4029 15.5834 8.49999C15.5834 4.59707 12.4029 1.41666 8.50002 1.41666ZM11.8859 6.87082L7.8696 10.8871C7.77044 10.9862 7.63585 11.0429 7.49419 11.0429C7.35252 11.0429 7.21794 10.9862 7.11877 10.8871L5.11419 8.88249C4.90877 8.67707 4.90877 8.33707 5.11419 8.13166C5.3196 7.92624 5.6596 7.92624 5.86502 8.13166L7.49419 9.76082L11.135 6.11999C11.3404 5.91457 11.6804 5.91457 11.8859 6.11999C12.0913 6.32541 12.0913 6.65832 11.8859 6.87082Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }